export default __webpack_public_path__ + "images/onboarding/mini-barfi-0b7552de652213711896c2e3c68d8976.svg";